import { EntityStatusTypes } from "@enums/entity-status-types";
import { AxnAcquiredAttribute } from "@idw-types/data/reference-data/axn/axn-acquired-attribute";
import { AttributesMap, AxnAcquiredAttributesMap, FormattedRpServiceConfigurationAttribute, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";

export const getAttributesMapAndAttributeTypeIds = (attributes: Array<FormattedRpServiceConfigurationAttribute>) => {
    const attributeTypeIds: Array<string> = [];
    const attributesMap = attributes.reduce((finalAttributesMap, attribute) => {
        finalAttributesMap[attribute.attributeType.id] = attribute;
        attributeTypeIds.push(attribute.attributeType?.id);
        return finalAttributesMap;
    }, {} as AttributesMap);

    return {
        attributesMap,
        attributeTypeIds
    }
}

export const getAxnAcquiredAttributesMap = (axnAcquiredAttributes: Array<AxnAcquiredAttribute>) => {
    return axnAcquiredAttributes.reduce((finalAxnAttributesMap, axnAcquiredAttribute) => {
        if (!finalAxnAttributesMap[axnAcquiredAttribute.serviceOfferingID]) {
            finalAxnAttributesMap[axnAcquiredAttribute.serviceOfferingID] = [axnAcquiredAttribute.attributeTypeID]
        } else {
            finalAxnAttributesMap[axnAcquiredAttribute.serviceOfferingID].push(axnAcquiredAttribute.attributeTypeID);
        }

        return finalAxnAttributesMap;
    }, {} as AxnAcquiredAttributesMap);
}

export const getActiveAcquiredAttributes = (serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>, attributes: Array<FormattedRpServiceConfigurationAttribute>, axnAcquiredAttributes: Array<AxnAcquiredAttribute>) => {
    const { attributeTypeIds, attributesMap } = getAttributesMapAndAttributeTypeIds(attributes)
    const axnAcquiredAttributesMap = getAxnAcquiredAttributesMap(axnAcquiredAttributes);

    const addedAttributeIds: Array<string> = [];
    return serviceOfferings.reduce((finalAcquiredAttributes, so) => {
        if (so.addedToService && so.status === EntityStatusTypes.ACTIVE) {
            if (axnAcquiredAttributesMap[so.serviceOfferingID]) {
                axnAcquiredAttributesMap[so.serviceOfferingID].forEach(attributeTypeID => {
                    if (attributeTypeIds.includes(attributeTypeID) && !addedAttributeIds.includes(attributeTypeID)) {
                        finalAcquiredAttributes.push(attributesMap[attributeTypeID]);
                        addedAttributeIds.push(attributeTypeID);
                    }
                });
            }
        }

        return finalAcquiredAttributes

    }, [] as Array<FormattedRpServiceConfigurationAttribute>);

}